<template>

<div class="flex-shrink-1 route-details filled-box-brand-secondary drop-down-hover">
	<div v-if="!editing" class="d-flex filled-box-header px-35" :class="config.layout === 'mobile' ? ' py-2' : 'py-25'">
		<span class="flex-grow-1 text-uppercase font-weight-bold" @click="toggleRouteDetails()" style="cursor: pointer">
			{{ route.title }}
			<i class="fas" :class="showRouteDetails == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
		</span>		
		<div v-if="route.can.update" class="drop-down" data-test="contextMenu">
			<a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
				<i class="far fa-ellipsis-h text-white text-lg" style="font-size:1.125rem"></i>
			</a>
			<div class="dropdown-menu dropdown-menu-right py-0" aria-labelledby="dropdownMenuLink">
				<a class="dropdown-item" href="#" v-on:click.stop="setEditing(true)" data-test="editRoute">Edit Route Details</a>
			</div>
		</div>
	</div>

	<div v-else class="filled-box-header px-35" :class="config.layout === 'mobile' ? ' py-2' : 'py-25'">
		<div class="text-uppercase font-weight-bold w-100">Route Title</div>
		<input class="form-control form-control-sm" v-model="form.title" data-test="editRouteTitle">
	</div>

	<template v-if="showRouteDetails">
		<div class="d-flex px-35 py-25">
			<div class="flex-fill" v-if="route.assigned_user" :class="{ 'w-60 mr-1' : editing }">
				<div class="text-uppercase font-weight-bold">Assigned</div>
				<div v-if="!editing" class="d-flex align-items-center">
					<div class="rounded-circle circle-cropped avatar-xs mr-1"><img :src="route.assigned_user.photo_url" class="img-fluid"></div>
					<span class="text-white">{{ route.assigned_user.display_name }}</span>
				</div>
				<v-select
					v-if="editing" 			                            
					label="display_name"
					:options="options.user_ids"
					:reduce="display_name => display_name.id"
					v-model="form.assigned_user_id"
					:clearable="false"
					data-test="editRouteUser"
				/>	
			</div>

			<div class="flex-fill text-right" :class="{ 'w-40' : editing }">
				<div class="text-uppercase font-weight-bold">Complete by</div>
				<span v-if="!editing" class="text-white">{{ route.complete_by ? route.complete_by : '--' }}</span>
				<date-picker v-else
					readonly="true"
					v-model="form.complete_by"
					:config="config.datePickerOptions"
					class="date-picker form-control-sm"
					data-test="editRouteEndDate" />
			</div>
		</div>

		<div class="px-35">
			<div class="section-divider"></div>
		</div>

		<div v-if="!editing" class="d-flex px-35 pt-25 pb-1">
			<div class="flex-fill text-uppercase font-weight-bold" @click="toggleTimestamps()" style="cursor: pointer;">
				Status <i class="fas" :class="showTimestamps == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
			</div>
			<div class="flex-fill text-right text-white" data-test="routeStatus">
				{{ route.status_text }} ({{ routeProgress }}%)
			</div>
		</div>

		<div v-if="!editing" class="px-35 pb-3">
			<div class="progress" style="height:4px">
				<div class="progress-bar bg-white" role="progressbar" :style="'width: ' + routeProgress + '%;'"></div>
			</div>
		</div>

		<div v-if="editing" class="px-35 pt-25 pb-2">
			<div class="flex-fill text-uppercase font-weight-bold">Status</div>
			<v-select
				v-if="editing" 			                            
				:options="[
					{ label:'New (not started)', value:0 },
					{ label:'In progress', value:1 },
					{ label:'Complete', value:2 },
					{ label:'Archived', value:3 },
				]"
				:reduce="label => label.value"
				v-model="form.status"
				:clearable="false"
			/>
		</div>

		<div v-if="editing" class="px-35 pb-25 text-right w-100">
			<span class="btn btn-sm btn-secondary" @click="setEditing(false)">Cancel</span>
			<span class="btn btn-sm btn-primary" @click="updateRoute()" data-test="saveEditRouteButton">Save Route</span>
		</div>

		<div v-if="showTimestamps" class="d-flex px-35 pb-2">
			<div class="flex-fill">
				<div class="text-uppercase font-weight-bold">Started On</div>
				<span class="text-white">{{ route.started_on ? moment(route.started_on).format("MMM D, YYYY") : '--' }}</span>
			</div>
			<div class="flex-fill text-right">
				<div class="text-uppercase font-weight-bold">Completed On</div>
				<span class="text-white">{{ route.ended_on ? moment(route.ended_on).format("MMM D, YYYY") : '--' }}</span>
			</div>
		</div>

	</template>
</div>

</template>

<script>
	import { mapState } from 'vuex';

  	export default {
		props: ['route', 'routeDetails'],

		data () {
			return {
				routeProgress: 0,
				showRouteDetails: null,
	        	showTimestamps: false,

	        	editing: false,

				form: {},        	
			}
		},

		mounted() {
			this.showRouteDetails = this.routeDetails;
			this.$root.$on('route_progress_changed', data => { 
				this.routeProgress = data;
			});

			this.$root.$on('route_updated', data => {
				this.editing = false;
			})
		},

		methods: {
			setEditing(value) {
				this.editing = value;
				if (value == true) {
					this.showRouteDetails = true;
					this.form = {
						title: this.route.title,
						assigned_user_id: this.route.assigned_user.id,
						complete_by: moment(this.route.complete_by),
						status: this.route.status,
					}
				}
			},

			toggleRouteDetails() {
				this.showRouteDetails = !this.showRouteDetails;
			},

			toggleTimestamps() {
				this.showTimestamps = !this.showTimestamps;
			},

			updateRoute() {
				this.$root.$emit('update_route', this.form);
			}
		},

		computed: {
			...mapState(['config', 'options'])
		}
	}
</script>